import {
  CVSS_31_MODIFIED_BASE_METRIC_KEYS,
  CVSS_31_MODIFIED_METRIC_ALLOWED_VALUES,
  CVSS_40_MODIFIED_BASE_METRIC_KEYS,
  CVSS_40_MODIFIED_METRIC_ALLOWED_VALUES,
  type CvssModifiedBaseMetrics,
} from '@terra/shared-cvss';

export type CvssVersionSetting = 'V3_1' | 'V4_0';

export type CvssModifiedMetricKey = keyof CvssModifiedBaseMetrics;

const IMPACT_METRIC_KEYS = new Set<CvssModifiedMetricKey>([
  'mc',
  'mi',
  'ma',
  'mvc',
  'mvi',
  'mva',
  'msc',
]);

const SUBSEQUENT_IMPACT_METRIC_KEYS = new Set<CvssModifiedMetricKey>([
  'msi',
  'msa',
]);

export const getModifiedMetricKeysForVersion = (
  version: CvssVersionSetting,
): readonly CvssModifiedMetricKey[] =>
  version === 'V4_0'
    ? CVSS_40_MODIFIED_BASE_METRIC_KEYS
    : CVSS_31_MODIFIED_BASE_METRIC_KEYS;

export const getModifiedMetricAllowedValues = ({
  key,
  version,
}: {
  key: CvssModifiedMetricKey;
  version: CvssVersionSetting;
}): readonly string[] => {
  if (version === 'V4_0') {
    if (!Object.hasOwn(CVSS_40_MODIFIED_METRIC_ALLOWED_VALUES, key)) {
      return ['X'];
    }

    return CVSS_40_MODIFIED_METRIC_ALLOWED_VALUES[
      key as keyof typeof CVSS_40_MODIFIED_METRIC_ALLOWED_VALUES
    ];
  }

  if (!Object.hasOwn(CVSS_31_MODIFIED_METRIC_ALLOWED_VALUES, key)) {
    return ['X'];
  }

  return CVSS_31_MODIFIED_METRIC_ALLOWED_VALUES[
    key as keyof typeof CVSS_31_MODIFIED_METRIC_ALLOWED_VALUES
  ];
};

export const getModifiedMetricValueLabelKey = ({
  key,
  value,
}: {
  key: CvssModifiedMetricKey;
  value: string;
}): string => {
  if (value === 'X') {
    return 'metricValues.X';
  }

  if (SUBSEQUENT_IMPACT_METRIC_KEYS.has(key)) {
    return `metricValues.subsequentImpact.${value}`;
  }

  if (IMPACT_METRIC_KEYS.has(key)) {
    return `metricValues.impact.${value}`;
  }

  return `metricValues.${key}.${value}`;
};
